import React, { useCallback, useState } from "react";
import { CarouselProps } from "./carousel.types";
import { UnControlledCarousel } from "./uncontrolled-carousel";

/**
 *
 * Slider of images or content.
 */
export const Carousel = ({ selectedSlide, onChange, children, ...restProps }: CarouselProps) => {
  const [selectedSlideIndex, setSelectedSlideIndex] = useState(() => (selectedSlide ? selectedSlide : 0));
  const [controlledMode] = useState<boolean>(() => !!(selectedSlide || selectedSlide === 0));

  const handleSlideChange = useCallback(
    (index) => {
      if (typeof onChange === "function") {
        onChange(index);
      }

      if (!controlledMode) {
        setSelectedSlideIndex(index);
      }
      return true;
    },
    [controlledMode, onChange]
  );

  return (
    <UnControlledCarousel
      selectedSlide={controlledMode ? (selectedSlide as number) : selectedSlideIndex}
      onChange={handleSlideChange}
      {...restProps}
    >
      {children as React.ReactChild[]}
    </UnControlledCarousel>
  );
};
